export const getPhone = (str: string) => str?.replace(/(?!^\+)\D/g, '');
